export default "__VITE_ASSET__BvrSMrXO__"